module.exports = __webpack_public_path__ + "static/assets/64213236c2ea6563c91f8e7ade172578.png";